/**
 * Export Central for Atum Export Pro
 *
 * @copyright Stock Management Labs ©2019
 *
 * @since 1.0.0
 */

/**
 * Third Party Plugins
 */
import '../../../../atum-stock-manager-for-woocommerce/assets/js/vendor/select2';


/**
 * Components
 */
import Tooltip from "../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/_tooltip";
import Globals from "./components/export-central/_globals";
import ExportSettings from './config/_export-settings';
import Router from './components/export-central/_router';


// Modules that need to execute when the DOM is ready should go here.
jQuery( ($) => {

    window['$'] = window['jQuery'];

    // Get the settings from localized var.
    let settings = new ExportSettings('AtumExportVars');
    let tooltip = new Tooltip();
    let globals = new Globals(settings);

    new Router(settings, tooltip, globals);
	
	// Display hidden footer.
	$(window).on('load', () => $('#wpfooter').show());

});


// WEBPACK FOOTER //
// ./assets/js/src/export-central.ts